import type { PrescreenContextView } from '@/modules/candidates/components/CandidateLedgerAssessment';
import type {
  CandidateAssessmentApi,
  CandidateJobApi,
} from '@/modules/candidates/types';

export function getCandidateDisplayScore(
  candidateJob: Pick<CandidateJobApi, 'assessment' | 'score'>,
): number | null {
  return candidateJob.assessment.mode === 'ledger'
    ? candidateJob.assessment.displayedScore
    : (candidateJob.score ?? null);
}

export function prescreenContextFromAssessment(
  response: CandidateAssessmentApi,
): PrescreenContextView {
  return {
    questionSelectionAvailability: response.questionSelectionAvailability,
    preparedQuestionSelection: response.preparedQuestionSelection,
    conversationQuestionSelection: response.conversationQuestionSelection,
    latestAttempt: response.latestPrescreenAttempt,
  };
}
